import { render, staticRenderFns } from "./ProjectCategoryNew.vue?vue&type=template&id=06539d3b&"
import script from "./ProjectCategoryNew.vue?vue&type=script&lang=js&"
export * from "./ProjectCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports